const Filter = require('../../../shared/ctxFiltersPanel/ctxFilterModel');
const Target = require('../../model/Target');
const TableState = require('../../model/TableState');
const { permissions } = require('../../constants/permissions');

class TargetsPersistenceService {
    constructor($rootScope, $filter, $timeout, $q, crudService, notificationService, sseService, sharedPersistenceService, storageService, iamPersistenceService) {
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this._$q = $q;
        this.crudService = crudService;
        this.notificationService = notificationService;
        this.iamPersistenceService = iamPersistenceService;
        this.sseService = sseService;
        this.storageService = storageService;
        this.TARGET_ENDPOINT = sharedPersistenceService.getRestEndpoints().TARGET_ENDPOINT;
        this.initFilter();

        this.$rootScope.$on("logout", () => {
            this.targetsTableState = undefined;
            this.filters.forEach((filter) => {
                filter.clear();
            });
            this.storageService.clearCustomPageSize('targets');
        });

        this.$rootScope.$on("force-logout", () => {
            this.targetsTableState = undefined;
            this.filters.forEach((filter) => {
                filter.clear();
            });
            this.storageService.clearCustomPageSize('targets');
        });
    }

    initFilter() {
        this.filters = [];
        this.filters.push(Filter.getCheckboxFilter(this.$filter('translate')('target.filters.targetType'), Target.getTargetTypeKey(), Target.getTargetTypeOptions(), 'targetType'));
        this.filters.push(Filter.getCheckboxFilter(this.$filter('translate')('target.filters.health'), Target.getHealthKey(), Target.getHealthOptions(), 'health'));
    }

    get(firstPage, isExport) {
        if (!this.iamPersistenceService.hasPermissions(permissions.TARGET_LISTING)) {
            return this._$q((resolve) => { resolve([]); });
        }
        if (firstPage && this.targetsTableState) {
            this.targetsTableState.page = 1;
        }
        if (!this.targetsTableState) {
            this.targetsTableState = new TableState();
            this.targetsTableState.orderBy = 'name';
            // check if custom pageSize is set
            let tempPageSize = this.storageService.getCustomPageSize('targets');
            if (tempPageSize) {
                this.targetsTableState.pageSize = tempPageSize;
            }
        }
        return this.crudService.getPagedWithStructuredFilter(this.TARGET_ENDPOINT, this.targetsTableState, this.filters, null, Target.getSearchKey(), null, isExport).then(res => {
            let searchBy = undefined;
            if (angular.isDefined(this.targetsTableState.searchBy)) {
                searchBy = this.targetsTableState.searchBy;
            }
            this.targetsTableState = res.data.tableState;
            this.targetsTableState.searchBy = searchBy;

            // set pageSize value
            if (this.targetsTableState && this.targetsTableState.pageSize) this.storageService.setCustomPageSize('targets', this.targetsTableState.pageSize);

            return res.data.entities.map(Target.fromRaw);
        });
    }

    getTarget(uuid) {
        if (!this.iamPersistenceService.hasPermissions(permissions.TARGET_DETAILS)) {
            return this._$q((resolve) => { resolve([]); });
        }
        return this.crudService.get(`targets/${uuid}`);
    }

    save(addTargetRequest) {
        return this.crudService.post('targets', addTargetRequest);
    }

    saveWithName(addTargetRequest) {
        return this.crudService.post('targets/targetName', addTargetRequest);
    }

    update(updateTargetRequest, uuid) {
        return this.crudService.put(`targets/${uuid}`, updateTargetRequest);
    }

    getAzureTargets(searchString) {
        if (!this.azureTargetsTableState) {
            this.azureTargetsTableState = new TableState();
            this.azureTargetsTableState.orderBy = 'name';
        }

        if (searchString) {
            return this.crudService.get('targets/azure?filter=name%23%23' + searchString + '&orderBy=' + this.azureTargetsTableState.orderBy, null, null, null, null, null, null, false).then(resp => resp.data.entities);

        } else {
            return this.crudService.get('targets/azure?orderBy=' + this.azureTargetsTableState.orderBy, null, null, null, null, null, null, false).then(resp => resp.data.entities);
        }
    }

    delete(selectedTarget) {
        return this.crudService.del(this.TARGET_ENDPOINT, selectedTarget.uuid)
            .then(resp => {
                this.notificationService.pop(resp.data.message);
            }, err => {
            });
    }

    toggleActive(target, activate) {
        return this.crudService.post(this.TARGET_ENDPOINT + '/' + encodeURI(target.uuid) + '/' + (activate ? 'activate' : 'deactivate'));
    }

    getAllTargets(searchBy, isExport) {
        let tableState = new TableState();
        tableState.pageSize = 1000000;
        if (searchBy) {
            tableState.searchBy = this.targetsTableState.searchBy;
        }
        return this.crudService.getPagedWithStructuredFilter(this.TARGET_ENDPOINT, tableState, this.filters, false, Target.getSearchKey(), null, isExport).then(res => {
            return res.data.entities.map(Target.fromRaw);
        });
    }
}

TargetsPersistenceService.$inject = ['$rootScope', '$filter', '$timeout', '$q', 'crudService', 'notificationService', 'sseService', 'sharedPersistenceService', 'storageService', 'iamPersistenceService'];

module.exports = TargetsPersistenceService;



// WEBPACK FOOTER //
// ./src/azurebackup/views/targets/targets.persistence.service.js